<template>
  <div class="context">
    <div class="context__wrapper">
      <div class="context__choices-wrapper">
        <button
          v-for="(context, i) in contexts"
          :key="`search-context-${i}`"
          :class="[
            'context__choice',
            currentContext === context && 'context__chosen',
            itemsLength[context] === 0 && 'context__disabled',
          ]"
          @click="updateContext(context)"
        >
          {{ context }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Context',
  props: {
    contexts: {
      type: Array,
      required: true,
    },
    currentContext: {
      type: String,
      required: true,
    },
    itemsLength: {
      type: Object,
      required: true,
    },
  },
  watch: {
    itemsLength: {
      deep: true,
      handler(items) {
        this.handleEmptyResults(items)
      },
    },
  },
  methods: {
    handleEmptyResults(items) {
      const { currentContext: context } = this
      if (items[context] === 0 && context !== 'Courses') {
        this.updateContext('Courses')
      }
    },
    updateContext(context) {
      this.$emit('update-context', context)
    },
  },
}
</script>

<style lang="scss" scoped>
.context {
  width: 100%;
  &__wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__choices-wrapper {
    display: flex;
    width: 100%;
  }
  &__choice {
    white-space: nowrap;
    background: transparent;
    color: var(--white);
    margin: 0 5px 0 0;
    transition: 0.5s all ease;
    border: none;
    padding: 0 0 10px 0;
    font-size: 1rem;
    margin: 0 30px 0 0;
    text-transform: uppercase;
    &:hover {
      cursor: pointer;
    }
  }
  &__chosen {
    font-family: var(--font-bold);
    border-bottom: 1px solid var(--orange);
  }
  &__disabled {
    opacity: 0.3;
    pointer-events: none;
  }
}
</style>
